import React from 'react';
import * as THREE from 'three';
import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer";
import { GetRoundNum } from "./Common";
import ReactDOMServer from 'react-dom/server';
import { ImArrowDown, ImArrowUp } from "react-icons/im";
import { useViewerStore } from "../../../../../store/store";
import { TreeGroup } from '../../../../../@types/types';

export function UpdateTreeMuliplier(modelGroup: TreeGroup) {
    const treeLabelGroup = modelGroup.children.find((group: { name: string }) => group.name === 'treeLabelGroup');
    const isTreeMultiplierLabelVisible = useViewerStore.getState().isTreeMultiplierLabelVisible;

    // Clear all existing children from the treeLabelGroup
    while (treeLabelGroup && treeLabelGroup.children.length > 0) {
        treeLabelGroup.remove(treeLabelGroup.children[0]);
    }

    const treeArr: any[] = [];

    modelGroup.traverse((child: any) => {
        if (child.meshType === 'tree' && child.name === 'wrapper') {
            treeArr.push(child.parent);
        }
    })

    treeArr.forEach(tree => {
        const { position, treeImpact, userData, totalH } = tree;
        const tree_multiplier = GetRoundNum(treeImpact, 4);
        const labelColor = getLabelCol(tree_multiplier);
        const treeLabelHeight = totalH + 0.5;
        const content = `${getMultiplierLabelPrefix(true, false, 12)}${tree_multiplier}`;
        const treeLabelObj = createLabel(content, labelColor, new THREE.Vector3(position.x, treeLabelHeight, position.z));
        treeLabelObj.name = Number(tree_multiplier);
        treeLabelObj.userData.treeId = userData.treeId
        treeLabelObj.visible = isTreeMultiplierLabelVisible;
        userData.multiplier = {};
        userData.multiplier.value = tree_multiplier || '0';
        userData.multiplier.color = labelColor;

        if (!treeLabelGroup) return;
        const existingChildIndex = treeLabelGroup.children.findIndex((child: any) => child.userData.treeId === userData.treeId);
        if (existingChildIndex !== -1) {
            if (treeImpact > 0) {
                treeLabelGroup.children[existingChildIndex] = treeLabelObj;
            } else {
                treeLabelGroup.remove(treeLabelGroup.children[existingChildIndex]);
            }
        } else {
            if (treeImpact > 0) treeLabelGroup.add(treeLabelObj);
        }
    });
}

export function getMultiplierLabelPrefix(upArrow: boolean, arrowColor: boolean, size: number) {
    const color = arrowColor ? (upArrow ? '#0f0' : '#f00') : undefined;
    const arrowElement = React.createElement(
        upArrow ? ImArrowUp : ImArrowDown,
        { size, color }
    );
    const arrowUpHTML = ReactDOMServer.renderToString(arrowElement);
    return `M ${arrowUpHTML}`;
}

export function createLabel(contents: string, color: string, position: THREE.Vector3) {
    const div = document.createElement('div');
    div.className = 'tree-epc-label';
    div.style.color = color;
    div.innerHTML = contents;

    const label: any = new CSS2DObject(div);
    label.labelColor = color;
    label.position.copy(position);
    return label;
}

function getLabelCol(value: number) {
    var r = 0, g = 0, b = 0;
    if (value <= 0) {
        r = 255;
    } else if (value > 0 && value <= 0.05) {
        var ratio = value / 0.05
        g = Math.round(100 + 155 * ratio);
        r = Math.round(255 * (1 - ratio));
    } else if (value > 0.05) {
        g = 255;
    }
    const h = r * 0x10000 + g * 0x100 + b * 0x1;
    const hexStr = '#' + ('000000' + h.toString(16)).slice(-6)
    return hexStr;
}
